import React from "react";
import { Card, Table } from "react-bootstrap";
import styles from "./index.module.css";
import GlobalPagination from "./Pagination";
import { usePagination, useTable } from "../../context/TableContext.v2";
import Skeleton from "react-loading-skeleton";

export const GlobalTable = ({ columns, rows, forceShowPagination = false }) => {
  const { loading: isLoading } = useTable();
  const { itemsPerPage } = usePagination();

  return (
    <>
      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body className="pt-0 p-0">
          <div className={styles.tableContainer}>
            <Table
              hover
              className="user-table align-items-center table-striped"
            >
              <thead className={styles.stickyHeader}>
                <tr>
                  {columns.map((col) => (
                    <th key={col.id}>{col.label}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  Array.from({ length: itemsPerPage }).map((_, index) => (
                    <tr key={index}>
                      {columns.map((_, colIndex) => (
                        <td key={colIndex}>
                          <Skeleton width={100} />
                        </td>
                      ))}
                    </tr>
                  ))
                ) : !rows.length ? (
                  <tr>
                    <td className="bg-grey text-center" colSpan={100}>
                      No Data Found.
                    </td>
                  </tr>
                ) : (
                  rows.map((row, index) => (
                    <tr
                      key={row._id}
                      className={index % 2 === 0 ? "even-row" : "odd-row"}
                    >
                      {columns.map((col) => (
                        <td
                          key={col.id}
                          className={
                            row.updatedKeys?.includes(col.id)
                              ? col?.isCritical
                                ? row.status === "Critical Field(s) Approved"
                                  ? styles.updatedCell
                                  : styles.criticalCell
                                : styles.updatedCell
                              : ""
                          }
                        >
                          {row[col.id] ?? "-"}
                        </td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
            <GlobalPagination forceShowPagination={forceShowPagination} />
          </div>
        </Card.Body>

      </Card>
    </>
  );
};
